import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import AppRoutes from './components/AppRoutes';
import Profile from './components/Profile';
import AlterarSenha from './components/AlterarSenha';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <NotificationProvider>
            <Routes>
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<AppRoutes />} />
            </Routes>
          </NotificationProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
